import { Component, Input } from '@angular/core'
import { FormFieldComponent } from '@widgets/form-field/form-field.component'

@Component({
  selector: 'bdg-input-field-currency',
  templateUrl: './input-field-currency.component.html',
})
export class InputFieldCurrencyComponent extends FormFieldComponent {
  @Input()
  maxLength: number

  constructor() {
    super()
  }

  get error() {
    return this.control?.touched && this.control?.errors?.error
  }

  onChange(value) {
    if (this.maxLength) {
      this.control.patchValue(value.slice(0, this.maxLength))
    }
  }
}
